"use client"

import React, {useEffect} from "react";
import {UnstyledButton} from "@mantine/core";
import {TFile} from "@/form/article";
import {IChronicle} from "@/form";
import cx from "clsx";


interface IProps {
    data: {[key: number]: IChronicle[]};
}

const ChronicleTwContent: React.FC<IProps> = ({ data }) => {

    function sortNumbersDescending(numbers: number[]): number[] {
        // 返回一個降冪排序的新陣列
        return [...numbers].sort((a, b) => b - a);
    }

    return (
        <>
            <div>
                {
                    sortNumbersDescending(Object.keys(data).map(key => parseInt(key))).map((year: number, index: number) => (
                        <>
                            <div className="bg-[url('/images/BG-point.png')] bg-repeat-x bg-center">
                                <div
                                    className={cx("inline-block py-[12px] px-[20px] text-[21px] text-white rounded-full font-bold", index % 2 === 0 ? 'bg-[#69a7a3]' : 'bg-[#6ea8c5]')}>
                                    {year}
                                </div>
                            </div>
                            <div className="flex flex-col pl-[100px] space-y-[10px]">
                                {
                                    data[year].map(item => (
                                        <div className="flex gap-3">
                                            <div className="text-[20px] min-w-[43px]">
                                                {item.month === '00' ? '全年' : `${item.month}月`}
                                            </div>
                                            <div>
                                                {
                                                    item.url == null ? (
                                                        <div className="text-black text-[20px]">{item.title} </div>
                                                    ) : (
                                                        <UnstyledButton component="a" target="_blank" href={item.url}>
                                                            <div className="text-[#158a83] text-[20px]">{item.title} </div>
                                                        </UnstyledButton>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </>
                    ))
                }
            </div>
        </>
    );
}

export default ChronicleTwContent;